import { HStack, Text } from '@chakra-ui/react'
import { faCircle } from '@fortawesome/pro-light-svg-icons'
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons'

import { useFormContext } from '@redwoodjs/forms'

import Icon from 'src/components/widgets/Icon/Icon'
import { useCurrentUser } from 'src/lib/hooks/auth/useCurrentUser'

const OnlyAvailableOnItList: React.FC<{ name: string }> = ({ name }) => {
  const { setValue, watch } = useFormContext()
  const isOnlyAvailableOnItList = watch(name)

  const { brandColor: color } = useCurrentUser()

  return (
    <HStack
      data-testid="onlyOnItList-checkbox"
      borderRadius={12}
      border="1px solid"
      borderColor="sandstonePlus"
      justifyContent="space-between"
      p={4}
      onClick={() => {
        setValue(name, !isOnlyAvailableOnItList)
      }}
    >
      <Text className="body-small-emphasis">Only available on ItList?</Text>
      <Icon
        size="lg"
        color={isOnlyAvailableOnItList ? color : 'graphite'}
        icon={isOnlyAvailableOnItList ? faCircleCheck : faCircle}
      />
    </HStack>
  )
}

export default OnlyAvailableOnItList
